import { render, staticRenderFns } from "./FilmBox.vue?vue&type=template&id=92e7af6e&scoped=true&"
import script from "./FilmBox.vue?vue&type=script&lang=ts&"
export * from "./FilmBox.vue?vue&type=script&lang=ts&"
import style0 from "./FilmBox.vue?vue&type=style&index=0&id=92e7af6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e7af6e",
  null
  
)

export default component.exports